import * as _ from "lodash";
import { connect } from "react-redux";

import actions from "@/actions";

import { MapContainer as MapContainerComponent } from "./MapContainer";

const markLightsAsSelected = (map, lights) =>
    _.map(_.values(lights), (light) => {
        if (map.general.filteredFlags.length > 0) {
            light.filtered = _.some(
                map.general.filteredFlags,
                (filteredFlag) =>
                    typeof filteredFlag.value === "function"
                        ? filteredFlag.value([light])
                        : _.some(
                              light.flags,
                              (selectedFlag) =>
                                  filteredFlag.value === selectedFlag.value,
                          ),
            );
        } else if (map.general.searchedLights.length > 0) {
            light.filtered = _.some(
                map.general.searchedLights,
                (searchedLight) => _.isEqual(searchedLight, light),
            );
        } else {
            light.filtered = false;
        }
        if (map.general.mode.name === "add") {
            light.selected = _.some(
                map.values.mode.present.selectedLights,
                (selectedLight) => selectedLight === light.uniqueId,
            );
        } else {
            light.selected = _.some(
                map.general.selectedLights,
                (selectedLight) => selectedLight === light.uniqueId,
            );
        }
        return light;
    });

const mapStateToProps = ({ topBar, map }) => ({
    highlight: map.general.highlight,
    arrayOfLights: map.general.arrayOfLights,
    lights: markLightsAsSelected(map, map.values.global.present.lights),
    modeLights: markLightsAsSelected(map, map.values.mode.present.lights),
    mapSettings: map.general.settings,
    topBarOptions: topBar.options,
    mode: map.general.mode,
    pasteModeActivated: map.general.pasteMode.activated,
    filtering: map.general.filteredFlags.length > 0,
    searching: map.general.searchedLights.length > 0,
    selectionEnabled: map.general.selectionEnabled,
    groupGeometries: map.values.global.present.groupGeometries,
    editingGroupGeometry: map.general.editingGroupGeometry,
    selectedTool: map.general.selectedTool,
    markers: map.values.global.present.markers,
    modeMarkers: map.values.mode.present.markers,
    floorSpaceCatalogMap: map.general.floorSpaceCatalogMap,
});

const mapDispatchToProps = {
    changeMode: actions.map.general.changeMode,
    setHighlight: actions.map.general.setHighlight,
    paste: actions.map.general.paste,
    updateLights: actions.map.values.global.updateLights,
    toastr: actions.window.showMessage,
    addLights: actions.map.values.mode.addLights,
    selectLights: actions.map.general.selectLights,
    deselectLights: actions.map.general.deselectLights,
    setSelectedTool: actions.map.general.setSelectedTool,
    updateModeLights: actions.map.values.mode.updateLights,
    updateMarkers: actions.map.values.global.updateMarkers,
    addTemporaryMarker: actions.map.values.mode.addTemporaryMarker,
    updateModeMarkers: actions.map.values.mode.updateMarkers,
    selectMarker: actions.map.general.selectMarker,
};

export const MapContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(MapContainerComponent);

export * from "./edit-panel";
export * from "./legend-cluster";
export * from "./marker-edit-panel";
export * from "./save-changes";
export * from "./settings-modal";
export * from "./tools-bar";
export * from "./tools-bar-status";
export * from "./top-bar";
